import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/icon/delete-box-red.svg'


const _hoisted_1 = { class: "trayek-form" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl font-bold mb-5" }, "Tambah Roster", -1)
const _hoisted_3 = { class: "flex items-center justify-between mb-5" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tambah Bus"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Pilih nopol yang tersedia")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Simpan'), -1)
const _hoisted_6 = { class: "flex items-center gap-4 mb-5" }
const _hoisted_7 = { class: "text-xl" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Trayek ")
const _hoisted_9 = { class: "text-xl font-bold" }
const _hoisted_10 = { class: "text-xl" }
const _hoisted_11 = { class: "flex items-center justify-between mb-5" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-lg font-bold" }, "Tabel Plot"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-base font-normal text-grey" }, "Tabel dibawah merupakan roster susulan untuk trayek diatas")
], -1)
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "text-white font-bold text-sm" }, /*#__PURE__*/_toDisplayString('Tambah'), -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-12 gap-3 mb-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-3 text-sm font-bold text-grey required" }, "NOPOL"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "JAM BERANGKAT"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-2 text-sm font-bold text-grey required" }, "JAM DATANG"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-4 text-sm font-bold text-grey required" }, "SOPIR"),
  /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, "AKSI")
], -1)
const _hoisted_16 = { class: "col-span-3" }
const _hoisted_17 = { class: "col-span-2" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "col-span-4" }
const _hoisted_20 = { class: "col-span-1" }
const _hoisted_21 = {
  key: 0,
  src: _imports_0,
  alt: "delete",
  class: "cursor-not-allowed",
  style: {"width":"35px","height":"35px"}
}
const _hoisted_22 = ["onClick"]

import { computed, defineComponent, getCurrentInstance, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { Form, Field, FieldArray, ErrorMessage } from 'vee-validate'
import * as Yup from 'yup'
import Card from 'primevue/card'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import apiUseCase from '@/usecase/apiUseCase'
import { useRoute, useRouter } from 'vue-router'
import SelectFetch from '@/views/components/form/SelectAsync.vue'
import SelectFetchDefault from '@/views/components/form/SelectAsyncDefault.vue'
import ConfirmModal from '@/views/components/modal/ConfirmModal2.vue'
import moment from 'moment'


export default /*#__PURE__*/_defineComponent({
  __name: 'RosterContinueForm',
  setup(__props) {

const endpointRosterAirport = '/roster/v1/Roster/Airport'
const endpointTrayek = 'management/v1/Trayek'

const app = getCurrentInstance()
const {
  $icon,
  $toast
} = app!.appContext.config.globalProperties
const store = useStore()
const route = useRoute()
const router = useRouter()
const icon = $icon
const isLoading = ref(false)
const refConfirmModal = ref<InstanceType<typeof ConfirmModal>>()
const trayekId = ref(route.params.id)
const trayekData = ref(null) as any
const ritOptions = ref([]) as any

const defaultValue = ref({
  vehicle: null,
  // rit: null,
  departure: null,
  arrival: null,
  driver: null
})

const initialValue = reactive({
  data: [
    {
      vehicle: null,
      // rit: null,
      departure: null,
      arrival: null,
      driver: null
    }
  ]
})

const schema = Yup.object().shape({
  data: Yup.array().of(
    Yup.object().shape({
      vehicle: Yup.object().required('Bus tidak boleh kosong'),
      // rit: Yup.object().required('Rit tidak boleh kosong'),
      departure: Yup.string().required('Jam Keberangkatan Rit tidak boleh kosong'),
      arrival: Yup.string().required('Jam Kedatangan Rit tidak boleh kosong'),
      driver: Yup.object().required('Sopir tidak boleh kosong'),
    })
  ).test('is-unique-time', 'Jam Keberangkatan tidak boleh ada yang sama', (val) => {
    // console.log('val', val)
    if (!Array.isArray(val)) {
      return true
    }
    const set = new Set()
    // console.log('setX', set)
    for (let i = 0; i < val.length; i++) {
      if (val[i]) {
        const data = val[i].departure
        // console.log('pps', pps)
        if (data !== undefined) {
          if (set.has(data) && data) {
            // console.log('exist')
            return false
          }
          set.add(data)
        }
      }
    }
    return true
  })
})

const backToListPage = () => {
  router.push({
    name: 'roster-airport'
  })
}

const processSave = (payload: any) => {
  apiUseCase.postOrPut(`${endpointRosterAirport}/Additional`, null, payload)
    .then(({ error, message }) => {
      if (!error) {
        store.dispatch('setReloadDataList', true)
        store.dispatch('setShowModalFormDl', false)
        backToListPage()
        $toast.add({
          severity: 'success',
          detail: 'Roster Susulan berhasil disimpan',
          group: 'bc',
          closable: false,
          life: 3000
        })
      } else {
        store.dispatch('setShowModalFormDl', false)
        $toast.add({
          severity: 'error',
          detail: message,
          group: 'bc',
          closable: false,
          life: 3000
        })
      }
      store.dispatch('hideLoading')
    })
}

const onSubmit = (val: any) => {
  console.log('submit', val)
  // eslint-disable-next-line no-unused-expressions
  refConfirmModal.value?.openModal({
    title: 'Konfirmasi Roster ?',
    subTitle: 'Pastikan data roster sudah benar. Sistem tetap akan mengecek data',
    btnSubmitTitle: 'Simpan Perubahan',
    imgContent: require('@/assets/img/modal-confirmation/plotting-save.svg')
  }).then((isConfirm) => {
    if (isConfirm) {
      const payload: any[] = []
      val.data.forEach((data: any) => {
        const dataFormTemp = {
          rosterDate: moment().format('YYYY-MM-DD'),
          departureTime: `${data.departure}:00`,
          arrivalTime: `${data.arrival}:00`,
          condecturId: null,
          condecturUsername: null,
          condecturName: null,
          msVehicleId: data.vehicle.Id,
          regNumber: data.vehicle.Nopol,
          trayekId: trayekData.value.Id,
          trayekName: trayekData.value.Name,
          trayekCode: trayekData.value.Code,
          trayekTypeId: trayekData.value.TrayekType.Id,
          trayekTypeCode: trayekData.value.TrayekType.Code,
          trayekTypeName: trayekData.value.TrayekType.Name,
          seatCapacity: data.vehicle.SeatCapacity,
          // msRouteId: data.rit?.Id,
          trayekSubId: null,
          trayekClassName: data.vehicle.TrayekClass.Name,
          statusName: null,
          statusRemark: null,
          isTol: data.vehicle.Trayek.IsTol,
          ppOrder: 1,
          driverId: data.driver.Id,
          driverName: data.driver.Fullname,
          helperId: null,
          helperName: null
        }
        payload.push(dataFormTemp)
      })
      console.log('payload', payload)
      processSave(payload)
    }
  })
}

const getRitOptions = (data: any) => {
  data.forEach((val: any) => {
    ritOptions.value.push(val.MsRoute)
  })
  console.log('ritOptions', ritOptions.value)
}

const getTrayekDetail = (id: any) => {
  store.dispatch('showLoading')
  apiUseCase.get(`${endpointTrayek}/${id}`)
    .then(async ({ result }) => {
      console.log('res', result)
      trayekData.value = result
      // getRitOptions(trayekData.value?.TrayekRoute)
      store.dispatch('hideLoading')
    })
    .catch(() => {
      store.dispatch('hideLoading')
    })
}

onMounted(() => {
  getTrayekDetail(trayekId.value)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!isLoading.value)
      ? (_openBlock(), _createBlock(_unref(Form), {
          key: 0,
          onSubmit: onSubmit,
          "validation-schema": _unref(schema),
          "initial-values": initialValue,
          class: "form-container",
          validateOnMount: true
        }, {
          default: _withCtx(({ errors, values, setFieldValue, meta }) => [
            _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
              content: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, [
                    _hoisted_4,
                    _createElementVNode("div", null, [
                      _createVNode(_unref(Button), {
                        class: "flex gap-2",
                        type: "submit"
                      }, {
                        default: _withCtx(() => [
                          _hoisted_5
                        ]),
                        _: 1
                      })
                    ])
                  ]),
                  _createVNode(_unref(Card), { class: "card-no-shadow wrap-hjp-data-table" }, {
                    content: _withCtx(() => [
                      _createVNode(_unref(FieldArray), { name: "data" }, {
                        default: _withCtx(({ fields, push, remove, prepend }) => [
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                              _hoisted_8,
                              _createElementVNode("span", _hoisted_9, _toDisplayString(`${_unref(trayekData)?.MsClass.Name} | ${_unref(trayekData)?.IsTol ? 'Tol' : 'Non Tol'} |`), 1),
                              _createTextVNode(" " + _toDisplayString(_unref(trayekData)?.Name), 1)
                            ]),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(`(${_unref(moment)().format('DD MMMM YYYY')})`), 1)
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _hoisted_12,
                            _createElementVNode("div", null, [
                              _createVNode(_unref(Button), {
                                class: "flex gap-2",
                                onClick: ($event: any) => (prepend(defaultValue.value))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("span", {
                                    innerHTML: _unref(icon).svg.plusEva
                                  }, null, 8, _hoisted_13),
                                  _hoisted_14
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _hoisted_15,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fields, (data, i) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: i,
                                class: "grid grid-cols-12 gap-3 mb-3"
                              }, [
                                _createElementVNode("div", _hoisted_16, [
                                  _createVNode(_unref(Field), {
                                    id: `data[${i}].vehicle`,
                                    name: `data[${i}].vehicle`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(SelectFetch, _mergeProps({ placeholder: 'Pilih Bus' }, field, {
                                        modelValue: field.value,
                                        id: `vehicle-${i}`,
                                        inputId: `vehicle-${i}`,
                                        endpoint: "/management/v1/MsVehicle",
                                        searchCustom: [['activeOnly', '=', true], ['orderByHasTrayek', '=', true]],
                                        selectable: (v) => v.Trayek !== null,
                                        fieldLabel: (v) => v.Nopol,
                                        clearable: false,
                                        searchFields: ['nopol'],
                                        classname: 'custom-select'
                                      }), null, 16, ["modelValue", "id", "inputId", "selectable", "fieldLabel"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                                        key: 0,
                                        class: "invalid-feedback",
                                        name: `data[${i}].vehicle`
                                      }, null, 8, ["name"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_unref(Field), {
                                    id: `data[${i}].departure`,
                                    name: `data[${i}].departure`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_unref(InputText), _mergeProps({
                                        class: "departure-pp w-full mb-2",
                                        id: `departure-${i}`
                                      }, field, {
                                        modelValue: field.value,
                                        type: "time",
                                        placeholder: "Jam Berangkat"
                                      }), null, 16, ["id", "modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                                        key: 0,
                                        class: "invalid-feedback",
                                        name: `data[${i}].departure`
                                      }, null, 8, ["name"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_unref(Field), {
                                    id: `data[${i}].arrival`,
                                    name: `data[${i}].arrival`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(_unref(InputText), _mergeProps({
                                        class: "arrival-pp w-full mb-2",
                                        id: `arrival-${i}`
                                      }, field, {
                                        modelValue: field.value,
                                        type: "time",
                                        placeholder: "Jam Kedatangan"
                                      }), null, 16, ["id", "modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                                        key: 0,
                                        class: "invalid-feedback",
                                        name: `data[${i}].arrival`
                                      }, null, 8, ["name"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_unref(Field), {
                                    id: `data[${i}].driver`,
                                    name: `data[${i}].driver`
                                  }, {
                                    default: _withCtx(({ field }) => [
                                      _createVNode(SelectFetch, _mergeProps({
                                        endpoint: "/management/v1/User/all-user",
                                        inputId: `driver-${i}`,
                                        searchCustom: [['roles', '=', 'Driver'], ['activeOnly', '=', 'true']],
                                        fieldLabel: (v) => v.Fullname
                                      }, field, {
                                        modelValue: field.value,
                                        placeholder: "Pilih Sopir",
                                        classname: 'custom-select'
                                      }), null, 16, ["inputId", "fieldLabel", "modelValue"])
                                    ]),
                                    _: 2
                                  }, 1032, ["id", "name"]),
                                  (meta.touched)
                                    ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                                        key: 0,
                                        class: "invalid-feedback",
                                        name: `data[${i}].driver`
                                      }, null, 8, ["name"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _createElementVNode("div", _hoisted_20, [
                                  (fields.length === 1)
                                    ? (_openBlock(), _createElementBlock("img", _hoisted_21))
                                    : (_openBlock(), _createElementBlock("img", {
                                        key: 1,
                                        src: _imports_0,
                                        alt: "delete",
                                        class: "cursor-pointer",
                                        style: {"width":"35px","height":"35px"},
                                        onClick: ($event: any) => (remove(i))
                                      }, null, 8, _hoisted_22))
                                ])
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024),
                      (meta.touched)
                        ? (_openBlock(), _createBlock(_unref(ErrorMessage), {
                            key: 0,
                            class: "invalid-feedback",
                            name: `data`
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["validation-schema", "initial-values"]))
      : _createCommentVNode("", true),
    _createVNode(ConfirmModal, {
      ref_key: "refConfirmModal",
      ref: refConfirmModal
    }, null, 512)
  ]))
}
}

})